import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
const BOOKING_API_URL = "https://promo.namantechnolab.com/api/Trip/GetBookingDetails";
const UPDATE_GATEWAY_RS_URL = "https://promo.namantechnolab.com/api/Accounts/UpdateGatewayRS";
const AGENCY_KEY = "02AD68F3-9AE6-4148-85B1-E61D1F03991F";

const Spinner = () => (
  <div style={S.spinWrap}>
    <div style={S.spinner} />
    <p style={S.spinText}>Processing your payment & fetching booking details…</p>
  </div>
);

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookingData, setBookingData] = useState(null);
  const [step, setStep] = useState("payment"); // "payment" → "gateway" → "booking" → "redirect"

  // ✅ Payment gateway se aaya parameters
  const bookingId =
    searchParams.get("bookingId") ||
    searchParams.get("BookingId") ||
    sessionStorage.getItem("lastBookingId") ||
    "";

  const txnId =
    searchParams.get("txnid") ||
    searchParams.get("txnId") ||
    searchParams.get("transactionId") ||
    "";

  const orderId = searchParams.get("orderId") || searchParams.get("OrderId") || "";

  // ✅ Gateway response params (Telr se aayenge)
  const mihpayid = searchParams.get("mihpayid") || searchParams.get("ref") || "";
  const gwStatus = searchParams.get("status") || "success";
  const amount = searchParams.get("amount") || sessionStorage.getItem("lastAmount") || 0;
  const hash = searchParams.get("hash") || "";

  const paymentStatus = gwStatus;

  const called = useRef(false);

  useEffect(() => {
    console.log("💳 Payment Success Page");
    console.log("🎯 BookingId:", bookingId);
    console.log("📋 TxnId:", txnId);
    console.log("✅ Payment Status:", paymentStatus);

    if (called.current) return;
    called.current = true;

    if (!bookingId) {
      setError("No booking ID found. Cannot proceed.");
      setLoading(false);
      return;
    }

    // 1️⃣ Show payment success for 1 second
    setTimeout(() => {
      setStep("gateway");
      // 2️⃣ Pehle UpdateGatewayRS call karo
      updateGatewayRS(bookingId);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingId]);

  // ✅ STEP 1: UPDATE GATEWAY RS - Payment gateway response confirm karo
  const updateGatewayRS = async (id) => {
    setError(null);  
    setLoading(true);

    const gatewayResponseObj = {
      mihpayid,
      status: gwStatus,
      hash,
    };

    const payload = {
      BookingId: null,
      TransactionId: Number(id),
      RecAmount: Number(amount) || 0,
      GatewayResponse: JSON.stringify(gatewayResponseObj),
      GatewayStatus: gwStatus === "success" ? 1 : 0,
      UserKey: sessionStorage.getItem("lastUserKey") || "",
      IsTC: true,
      IsB2B: false,
      AccountNo: 11,
      AgencyKey: AGENCY_KEY,
    };
debugger;
    console.log("🔗 UpdateGatewayRS API:", UPDATE_GATEWAY_RS_URL);
    console.log("📤 UpdateGatewayRS Payload:", payload);

    try {
      const res = await fetch(UPDATE_GATEWAY_RS_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error(`HTTP Error ${res.status}`);
      }

      const data = await res.json();
      console.log("📥 UpdateGatewayRS Response:", data);

      // ✅ 3️⃣ UpdateGatewayRS success hone ke baad hi GetBookingDetails call karo
      setStep("booking");
      fetchBookingDetails(id);
    } catch (err) {
      console.error("❌ UpdateGatewayRS Error:", err);
      setError("Unable to verify payment gateway response. Please try again.");
      setLoading(false);
    }
  };

  // ✅ BOOKING DETAILS FETCH - UpdateGatewayRS ke baad
  const fetchBookingDetails = async (id) => {
    setError(null);
    setLoading(true);

    const payload = {
      APIToken: "",
      AgencyKey: AGENCY_KEY,
      AccountNo: "11",
      BookingId: String(id),
      AirlinePnr: "",
      IsFly: false,
      IsB2B: false,
      IsCreditNote: false,
      IsTC: true,
    };

    console.log("🔗 Booking API:", BOOKING_API_URL);
    console.log("📤 Booking Payload:", payload);

    try {
      const res = await fetch(BOOKING_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      console.log("📡 Response Status:", res.status);

      if (!res.ok) {
        throw new Error(`HTTP Error ${res.status}`);
      }

      const data = await res.json();
      console.log("📥 Booking Response:", data);
      console.log("📋 Response Fields:", Object.keys(data || {}));

      if (data?.ResponseStatus === 1 || data?.BookingId) {
        setBookingData(data);
        setStep("redirect");

        console.log("✅ Booking data milgaya! Redirecting to Ticket page...");
        setTimeout(() => {
          navigate("/ticket-details", {
            state: {
              bookingData: data,
              bookingId: id,
              txnId: txnId,
            },
          });
        }, 1000);
      } else {
        setError(data?.Error?.ErrorDesc || "Booking details not found.");
        setLoading(false);
      }
    } catch (err) {
      console.error("❌ Fetch Error:", err);
      setError("Unable to fetch booking details. Please try again.");
      setLoading(false);
    }
  };

  // Manual retry — gateway step se dobara start karo
  const handleRetry = () => {
    setStep("gateway");
    updateGatewayRS(bookingId);
  };

  // Error State
  if (error) {
    return (
      <div style={S.page}>
        <div style={{ ...S.card, maxWidth: 520, margin: "40px auto", textAlign: "center" }}>
          <div style={S.errorIcon}>❌</div>
          <h2 style={S.h2}>Error Processing Booking</h2>
          <p style={S.errorMsg}>{error}</p>
          <p style={S.mutedText}>
            Booking ID: <strong>{bookingId || "Not found"}</strong>
          </p>

          <div style={S.btnRow}>
            <button style={S.btnOutline} onClick={handleRetry}>
              🔄 Retry
            </button>
            <button style={S.btnPrimary} onClick={() => navigate("/")}>
              🏠 Go Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Success + Loading State
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        {/* Success Banner - ALWAYS VISIBLE */}
        <div style={S.successBanner}>
          <div>
            <div style={S.successIcon}>✅</div>
          </div>
          <div style={{ flex: 1 }}>
            <h1 style={S.successTitle}>Payment Successful!</h1>
            <p style={S.successSub}>
              {step === "payment" && "Your payment has been processed."}
              {step === "gateway" && "Verifying payment with gateway..."}
              {step === "booking" && "Fetching your booking details..."}
              {step === "redirect" && "Preparing your ticket... Redirecting soon!"}
            </p>
          </div>
        </div>

        {/* Loading Spinner */}
        {loading && <Spinner />}

        {/* Payment Details Card */}
        <div style={S.card}>
          <div style={S.cardTitle}>📋 Payment Information</div>
          <div style={S.infoRow}>
            <span style={S.infoLabel}>Booking ID</span>
            <span style={S.infoValue}>{bookingId || "—"}</span>
          </div>
          <div style={S.infoRow}>
            <span style={S.infoLabel}>Transaction ID</span>
            <span style={S.infoValue}>{txnId || "—"}</span>
          </div>
          {orderId && (
            <div style={S.infoRow}>
              <span style={S.infoLabel}>Order ID</span>
              <span style={S.infoValue}>{orderId}</span>
            </div>
          )}
          <div style={S.infoRow}>
            <span style={S.infoLabel}>Status</span>
            <span style={{ ...S.infoValue, color: "#15803d", fontWeight: 700 }}>
              ✅ {paymentStatus.toUpperCase()}
            </span>
          </div>
        </div>

        {/* Booking Data Card */}
        {bookingData && (
          <div style={S.card}>
            <div style={S.cardTitle}>📊 Booking Details</div>
            <div style={S.infoRow}>
              <span style={S.infoLabel}>Booking Reference</span>
              <span style={S.infoValue}>
                {bookingData.BookingReferenceNo || bookingData.PNR || "—"}
              </span>
            </div>
            {bookingData.Contracts?.[0]?.AirSegments?.[0] && (
              <>
                <div style={S.infoRow}>
                  <span style={S.infoLabel}>Route</span>
                  <span style={S.infoValue}>
                    {bookingData.Contracts[0].AirSegments[0].DepartureAirportCode} →{" "}
                    {bookingData.Contracts[0].AirSegments[0].ArrivalAirportCode}
                  </span>
                </div>
                <div style={S.infoRow}>
                  <span style={S.infoLabel}>Airline</span>
                  <span style={S.infoValue}>
                    {bookingData.Contracts[0].AirSegments[0].AirlineName || "—"}
                  </span>
                </div>
              </>
            )}
            {bookingData.TotalAmount && (
              <div style={S.infoRow}>
                <span style={S.infoLabel}>Total Amount</span>
                <span style={S.infoValue}>
                  ₹{Number(bookingData.TotalAmount).toLocaleString("en-IN")}
                </span>
              </div>
            )}
          </div>
        )}

        {/* Manual Redirect Button */}
        {bookingData && !loading && (
          <div style={S.actions}>
            <button
              style={S.btnPrimary}
              onClick={() =>
                navigate("/Ticket", {
                  state: {
                    bookingData: bookingData,
                    bookingId: bookingId,
                    txnId: txnId,
                  },
                })
              }
            >
              ➡️ View Ticket Details
            </button>
            <button style={S.btnOutline} onClick={() => navigate("/")}>
              🏠 Home
            </button>
          </div>
        )}

        {/* Progress Indicator */}
        <div style={S.progressBar}>
          <div style={{ ...S.progressStep, background: "#10b981" }}>
            <span style={S.stepNumber}>✅</span>
            <span style={S.stepLabel}>Payment</span>
          </div>
          <div style={S.progressLine} />
          <div
            style={{
              ...S.progressStep,
              background:
                step === "booking" || step === "redirect"
                  ? "#10b981"
                  : step === "gateway"
                  ? "#f59e0b"
                  : "#d1d5db",
            }}
          >
            <span style={S.stepNumber}>
              {step === "booking" || step === "redirect" ? "✅" : "⏳"}
            </span>
            <span style={S.stepLabel}>Gateway</span>
          </div>
          <div style={S.progressLine} />
          <div
            style={{
              ...S.progressStep,
              background: step === "redirect" ? "#10b981" : "#d1d5db",
            }}
          >
            <span style={S.stepNumber}>{step === "redirect" ? "✅" : "⏳"}</span>
            <span style={S.stepLabel}>Booking</span>
          </div>
          <div style={S.progressLine} />
          <div
            style={{
              ...S.progressStep,
              background: step === "redirect" ? "#10b981" : "#d1d5db",
            }}
          >
            <span style={S.stepNumber}>{step === "redirect" ? "✅" : "⏳"}</span>
            <span style={S.stepLabel}>Ticket</span>
          </div>
        </div>

        {/* Debug Info */}
        <div style={{ ...S.card, background: "#f5f5f5", marginTop: "2rem" }}>
          <div style={{ fontSize: 12, color: "#666", fontFamily: "monospace" }}>
            <p>
              📍 <strong>Current Step:</strong> {step}
            </p>
            <p>
              📍 <strong>Loading:</strong> {loading ? "Yes" : "No"}
            </p>
            <p>
              📍 <strong>Booking Data:</strong> {bookingData ? "Received ✅" : "Pending..."}
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    background: "#f8f9fb",
    padding: "2rem 1rem",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  wrap: {
    maxWidth: 860,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },

  spinWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "40vh",
    gap: 16,
  },
  spinner: {
    width: 44,
    height: 44,
    border: "4px solid #e5e7eb",
    borderTop: "4px solid #10b981",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  spinText: { color: "#6b7280", fontSize: 14 },

  successBanner: {
    background: "#f0fdf4",
    border: "1px solid #bbf7d0",
    borderRadius: 12,
    padding: "1.25rem 1.5rem",
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    flexWrap: "wrap",
  },
  successIcon: { fontSize: 48, flexShrink: 0 },
  successTitle: { fontSize: 24, fontWeight: 700, color: "#15803d", margin: 0 },
  successSub: { fontSize: 14, color: "#166534", marginTop: 8 },

  card: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "1.25rem 1.5rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
  cardTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#2563eb",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: "1rem",
    borderBottom: "1px solid #e5e7eb",
    paddingBottom: "0.75rem",
  },

  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0",
    fontSize: 14,
    borderBottom: "1px solid #f1f5f9",
  },
  infoLabel: { color: "#6b7280", fontWeight: 500 },
  infoValue: { fontWeight: 600, color: "#111827" },

  actions: { display: "flex", gap: 10, justifyContent: "center", padding: "1rem 0" },
  btnPrimary: {
    padding: "12px 28px",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    background: "#10b981",
    color: "#fff",
    transition: "background 0.3s",
  },
  btnOutline: {
    padding: "12px 28px",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    border: "1px solid #d1d5db",
    background: "#fff",
    color: "#374151",
    transition: "all 0.3s",
  },
  btnRow: { display: "flex", gap: 10, justifyContent: "center", marginTop: 16 },

  progressBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
    marginTop: "2rem",
    padding: "2rem 1rem",
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
  },
  progressStep: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: "0.75rem 1.5rem",
    borderRadius: 8,
    minWidth: 100,
  },
  stepNumber: {
    fontSize: 24,
    fontWeight: 700,
    color: "#fff",
  },
  stepLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
  },
  progressLine: {
    width: 40,
    height: 2,
    background: "#d1d5db",
  },

  errorIcon: { fontSize: 48, marginBottom: 8 },
  h2: { fontSize: 22, fontWeight: 700, color: "#111827", margin: "0 0 8px" },
  errorMsg: { fontSize: 14, color: "#6b7280", marginBottom: 8 },
  mutedText: { fontSize: 13, color: "#9ca3af", marginBottom: 4 },
};